"use client";
import React from "react";
import MenuGeneric from "./MenuGeneric";

const menuItems = [
  { path: "/", label: "Accueil" },
  { path: "/services", label: "Services" },
  { path: "/blog", label: "Blog", alternativePaths: ["/blogarticle"] },
  { path: "/parcours", label: "A propos" },
  { path: "/projets", label: "Projets" },
  { path: "/contact", label: "Contact" },
];

const MenuRecrutement = () => <MenuGeneric menuItems={menuItems} />;

export default MenuRecrutement;
